<template>
  <section>
    <b-form>
      <div class="border__bottom pb-4">
        <section class="max-w-lg">
          <input-default
            :label="$t('sectionGroupPermission.nameGroupPermission')"
          />
        </section>
      </div>
      <div class="w-full flex items-start pt-3 pb-2 border__bottom">
        <h2 class="text-red-500 text-2xl">
          {{ $t("sectionGroupPermission.permission") }}
        </h2>
      </div>
      <div class="grid grid-cols-1 md:grid-cols-12">
        <div class="col-span-8">
          <div class="grid grid-cols-12">
            <div
              class="col-span-12 lg:col-span-4 border__bottom py-2"
              :class="{ border__right: $mq.tablet }"
            >
              <div class="flex items-start">
                <h4 class="text-lg">
                  {{ $t("sectionGroupPermission.cardAdministrator") }}
                </h4>
              </div>
            </div>
            <div class="col-span-12 lg:col-span-6 border__bottom p-3">
              <CheckboxDefault
                :label="$t('sectionGroupPermission.register')"
                inputValue="cadastrar"
                v-model="selectedOptions"
              />
              <CheckboxDefault
                :label="$t('sectionGroupPermission.edit')"
                inputValue="editar"
                v-model="selectedOptions"
              />
              <CheckboxDefault
                :label="$t('sectionGroupPermission.list')"
                inputValue="listar"
                v-model="selectedOptions"
              />
              <CheckboxDefault
                :label="$t('sectionGroupPermission.delete')"
                inputValue="deletar"
                v-model="selectedOptions"
              />
            </div>
          </div>
        </div>

        <div class="col-span-8">
          <div class="grid grid-cols-12">
            <div
              class="col-span-12 lg:col-span-4 py-2"
              :class="{ border__right: $mq.tablet, border__bottom: $mq.mobile }"
            >
              <div class="flex flex-col items-start">
                <h4 class="text-lg">CT-e</h4>
              </div>
            </div>
            <div class="col-span-12 lg:col-span-6 p-3">
              <CheckboxDefault
                :label="$t('sectionGroupPermission.viewDocuments')"
                inputValue="visualizarDocumentos"
                v-model="selectedOptions"
              />
              <CheckboxDefault
                :label="$t('sectionGroupPermission.downloadDocuments')"
                inputValue="baixarDocumentos"
                v-model="selectedOptions"
              />
            </div>
          </div>
        </div>

        <div class="col-span-8">
          <div class="grid grid-cols-12">
            <div
              class="col-span-12 lg:col-span-4 border__bottom py-1"
              :class="{ border__right: $mq.tablet }"
            >
              <div class="flex flex-col items-start">
                <h4 class="text-lg">
                  {{ $t("sectionGroupPermission.companies") }}
                </h4>
              </div>
            </div>
            <div
              class="col-span-12 lg:col-span-6 border__bottom pt-2 pb-3 px-3"
            >
              <CheckboxDefault
                :label="$t('sectionGroupPermission.changeCompanyData')"
                inputValue="alterarDadosEmpresa"
                v-model="selectedOptions"
              />
              <CheckboxDefault
                :label="$t('sectionGroupPermission.changeCompanyCertificates')"
                inputValue="alterarCertificadosEmpresa"
                v-model="selectedOptions"
              />
              <CheckboxDefault
                :label="$t('sectionGroupPermission.viewAccessKey')"
                inputValue="visualizarChaveAcesso"
                v-model="selectedOptions"
              />
              <CheckboxDefault
                :label="$t('sectionGroupPermission.integrationTools')"
                inputValue="ferramentasIntegracao"
                v-model="selectedOptions"
              />
              <CheckboxDefault
                :label="$t('sectionGroupPermission.changeCompanyBrands')"
                inputValue="alterarMarcasEmpresa"
                v-model="selectedOptions"
              />
              <CheckboxDefault
                :label="$t('sectionGroupPermission.changeParameters')"
                inputValue="alterarParametros"
                v-model="selectedOptions"
              />
            </div>
          </div>
        </div>

        <div class="col-span-8">
          <div class="grid grid-cols-12">
            <div
              class="col-span-12 lg:col-span-4 border__bottom py-2"
              :class="{ border__right: $mq.tablet }"
            >
              <div class="flex items-start">
                <h4 class="text-lg">
                  {{ $t("sectionGroupPermission.general") }}
                </h4>
              </div>
            </div>
            <div class="col-span-12 lg:col-span-6 border__bottom p-3">
              <CheckboxDefault
                :label="$t('sectionGroupPermission.importDocuments')"
                inputValue="importarDocumentos"
                v-model="selectedOptions"
              />
              <CheckboxDefault
                :label="$t('sectionGroupPermission.reports')"
                inputValue="relatorios"
                v-model="selectedOptions"
              />
              <CheckboxDefault
                :label="$t('sectionGroupPermission.changeMailboxes')"
                inputValue="alterarCaixarEmail"
                v-model="selectedOptions"
              />
              <CheckboxDefault
                :label="$t('sectionGroupPermission.viewQuantitiesIssued')"
                inputValue="visualizarQuantidadesEmitidas"
                v-model="selectedOptions"
              />
            </div>
          </div>
        </div>
      </div>

      <footer class="w-full flex items-center justify-start gap-5 my-10">
        <Button
          class="bg-green-500 shadow shadow-[rgba(200, 200, 200, 0.7)] hover:bg-green-600 transition-all duration-300"
          buttonText="Confirmar"
          :onClick="openModal"
        />
        <Button
          class="bg-red-500 shadow shadow-[rgba(200, 200, 200, 0.7)] hover:bg-red-600 transition-all duration-300"
          buttonText="Cancelar"
          :onClick="redirectUrl"
        />
        <Modal
          v-if="modalIsOpen"
          :modalIsOpen="modalIsOpen"
          :closeModal="closeModal"
          :modalText="$t('commons.modalTextEdit')"
          modalFeaturedText="sucesso!"
        />
      </footer>
    </b-form>
  </section>
</template>

<script>
import Button from "@core/components/commons/button/Button";
import Modal from "@core/components/commons/modal/Modal";
import InputDefault from "@core/components/commons/inputs/InputDefault";
import CheckboxDefault from "@core/components/commons/checkbox/CheckboxDefault";

import { BForm } from "bootstrap-vue";

export default {
  name: "ManageGroupPermissionsEdit",
  components: {
    BForm,
    CheckboxDefault,
    InputDefault,
    Button,
    Modal,
  },
  data() {
    return {
      modalIsOpen: false,
      selectedOptions: [],
    };
  },
  methods: {
    redirectUrl() {
      return this.$router.push("/groupPermission");
    },
    openModal() {
      this.modalIsOpen = true;
    },
    closeModal(event) {
      if (event.target === event.currentTarget) {
        this.modalIsOpen = false;
        window.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      }
    },
  },
};
</script>

<style scoped>
.border__bottom {
  border-bottom: 1px solid rgba(200, 200, 200, 0.8);
}

.border__right {
  border-right: 1px solid rgba(200, 200, 200, 0.8);
}
</style>
